import { MoldOrderType, MoldOrderFirstLevelType, OrderDetail } from '../../types/mold';
import { BaseMoldOrderModel } from './base';

/**
 * Repair mold order model
 * Handles all repair-related order types and their specific logic
 */
export class RepairMoldOrderModel extends BaseMoldOrderModel {
  readonly type: MoldOrderFirstLevelType = 'repair';
  readonly label = 'ซ่อมแม่พิมพ์';
  readonly description = 'ใบงานสำหรับการซ่อมแซมและปรับปรุงแม่พิมพ์';
  readonly iconColor = 'text-orange-600';
  readonly headerBgColor = 'bg-gradient-to-br from-orange-50 to-orange-100/70';
  readonly headerBorderColor = 'border-orange-200/60';
  readonly headerShadow = 'shadow-lg shadow-orange-100/20';
  readonly headerTextColor = 'text-orange-900';

  getDefaultMoldOrderType(): MoldOrderType {
    return MoldOrderType.REPAIR_MINOR;
  }

  getAvailableMoldOrderTypes(): MoldOrderType[] {
    return [
      MoldOrderType.REPAIR_MINOR,
      MoldOrderType.REPAIR_MAJOR,
    ];
  }

  createInitialOrderDetail(): OrderDetail {
    return {
      moldOrderType: this.getDefaultMoldOrderType(),
      note: '',
      form: {}
    };
  }

  validateOrderDetail(orderDetail: OrderDetail): { isValid: boolean; errors: string[] } {
    const errors: string[] = [];

    if (!orderDetail.moldOrderType) {
      errors.push('กรุณาเลือกประเภทงาน');
    }

    return {
      isValid: errors.length === 0,
      errors,
    };
  }

  getRequiredFormFields(): string[] {
    return ['moldOrderType'];
  }

  /**
   * Get priority level for repair order
   */
  getRepairPriority(moldOrderType: MoldOrderType): 'high' | 'medium' | 'low' {
    switch (moldOrderType) {
      case MoldOrderType.REPAIR_MAJOR:
        return 'high'; // Production stoppage is critical
      case MoldOrderType.REPAIR_MINOR:
        return 'medium'; // Can wait until production lot is complete
      default:
        return 'low';
    }
  }

  /**
   * Create initial order detail with repair-specific logic
   */
  createInitialOrderDetailForRepair(moldOrderType: MoldOrderType): OrderDetail {
    const base = this.createInitialOrderDetail();

    return {
      ...base,
      moldOrderType
    };
  }

  requiresStorageLocation(): boolean {
    return false;
  }
  requiresShiftCompletedInfo(): boolean {
    return false;
  }
  requiresMachineToProduce(): boolean {
    return false;
  }
}
